import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  background-color: #1a1a2e;
  padding: 48px 0 24px;
  color: #fff;
`;

const FooterContent = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 16px;
`;

const FooterTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 40px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 32px;
  }
`;

const FooterBrand = styled.div`
  max-width: 280px;
`;

const BrandName = styled.div`
  font-size: 1.15rem;
  font-weight: 700;
  color: #fff;
  margin-bottom: 4px;
`;

const BrandTagline = styled.div`
  font-size: 0.75rem;
  color: #888;
  margin-bottom: 16px;
`;

const BrandDescription = styled.p`
  font-size: 0.8rem;
  color: #888;
  line-height: 1.6;
  margin: 0;
`;

const FooterGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, auto);
  gap: 48px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
  }
`;

const FooterColumn = styled.div`
  h4 {
    color: #fff;
    font-size: 0.8rem;
    margin-bottom: 14px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
`;

const FooterLink = styled(Link)`
  display: block;
  color: #999;
  text-decoration: none;
  margin-bottom: 8px;
  font-size: 0.8rem;
  transition: color 0.2s;

  &:hover {
    color: #fff;
  }
`;

const Divider = styled.hr`
  border: none;
  border-top: 1px solid #333;
  margin: 0 0 20px 0;
`;

const BottomBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }
`;

const BottomLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  font-size: 0.75rem;
  color: #666;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 8px;
  }
`;

const Copyright = styled.span``;

const BottomRight = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 0.75rem;
  color: #666;
`;

const ContactLink = styled.a`
  color: #888;
  text-decoration: none;
  transition: color 0.2s;

  &:hover {
    color: #fff;
  }
`;

const BuiltBy = styled.span`
  a {
    color: #888;
    text-decoration: none;
    transition: color 0.2s;

    &:hover {
      color: #fff;
    }
  }
`;

const Footer = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterTop>
          <FooterBrand>
            <BrandName>ShowingBooker</BrandName>
            <BrandTagline>Compliant Showings Made Simple</BrandTagline>
            <BrandDescription>
              The industry's leading showing management platform for tenant-occupied properties.
              Built for compliance-first real estate professionals.
            </BrandDescription>
          </FooterBrand>

          <FooterGrid>
            <FooterColumn>
              <h4>Platform</h4>
              <FooterLink to="/how">How It Works</FooterLink>
              <FooterLink to="/compare">Why ShowingBooker</FooterLink>
              <FooterLink to="/about">About Us</FooterLink>
              <FooterLink to="/contact">Contact</FooterLink>
            </FooterColumn>

            <FooterColumn>
              <h4>Resources</h4>
              <FooterLink to="/tenant-rights">For Tenants</FooterLink>
              <FooterLink to="/agent-liability">For Agents</FooterLink>
              <FooterLink to="/owner-protection">For Owners</FooterLink>
            </FooterColumn>

            <FooterColumn>
              <h4>Legal</h4>
              <FooterLink to="/terms">Terms of Service</FooterLink>
              <FooterLink to="/privacy">Privacy Policy</FooterLink>
              <FooterLink to="/sms-policy">SMS Policy</FooterLink>
              <FooterLink to="/email-policy">Email Policy</FooterLink>
            </FooterColumn>
          </FooterGrid>
        </FooterTop>

        <Divider />

        <BottomBar>
          <BottomLeft>
            <Copyright>© 2025-2026 ShowingBooker LLC</Copyright>
            <span>Calabasas, CA</span>
          </BottomLeft>
          <BottomRight>
            <ContactLink href="mailto:david@codexdeus.com">david@codexdeus.com</ContactLink>
            <BuiltBy>
              Built by{' '}
              <a href="https://codexdeus.com" target="_blank" rel="noopener noreferrer">
                CodexDeus
              </a>
            </BuiltBy>
          </BottomRight>
        </BottomBar>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer;
